import React from "react";

const Spacer = ({ size }) => {
  return <div style={{ height: `${size || 60}px` }}></div>;
};

export default Spacer;

//! Spacer in görevi Customer Service yazısı gibi section title için boşluk bırakır....
